module.exports = " <input type=text autocomplete=off v-model=query @keydown.up=up @keydown.down=down @keydown.enter=hit @keydown.esc=reset @blur=reset placeholder=\"{{ translate('cp.search') }}...\"/> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/typeahead/Input.vue
// module id = 394
// module chunks = 0